import React from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import Alert from 'react-s-alert';

import Profiles from 'api/resources/profiles';
import { Deserializer } from 'jsonapi-serializer';
import { processErrorByAlert } from 'utils/getErrors';

import { COLORS } from 'styleguide';

import Label from 'styled/Label';
import SmallFormTextarea from 'styled/Editor/SmallFormTextarea';
import PrimaryButton from 'styled/Buttons/PrimaryButton';
import SecondaryButton from 'styled/Buttons/SecondaryButton';
import Header from 'styled/Page/Header';

class UserProfileForm extends React.PureComponent {
  state = {
    loading: false,
    comment: this.props.comment,
    status: this.props.status,
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.status !== this.state.status) {
      this.formSubmit();
    }
  }

  handleCommentChange = ({ target }) => {
    this.setState({ comment: target.value });
  }

  handleAcceptClick = () => {
    this.setState({ status: 'accepted' });
  }

  handleRejectClick = () => {
    this.setState({ status: 'rejected' });
  }

  formSubmit = async () => {
    this.setState({ loading: true });

    try {
      const response = await Profiles.patch({
        profileId: this.props.id,
        body: {
          data: {
            type: 'profile',
            attributes: {
              comment: this.state.comment,
              status: this.state.status,
            },
          },
        },
      });

      const profile = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState({ loading: false });
      Alert.success('Статус анкеты успешно изменен');
      this.props.onStatusUpdate(profile);
    } catch (err) {
      processErrorByAlert(err);
      this.setState({ loading: false });

      Raven.captureException(err, { extra: this.props });
    }
  }

  render() {
    return (
      <React.Fragment>
        <Header style={{ margin: '0 0 24px', minHeight: 'auto' }} />

        <Label htmlFor="comment">
          {this.props.status === 'rejected'
            ? 'Комментарий'
            : 'Добавить комментарий'
          }
        </Label>

        <SmallFormTextarea
          id="comment"
          value={this.state.comment}
          onChange={this.handleCommentChange}
          style={{ marginBottom: '40px', borderColor: COLORS.gray60 }}
          disabled={this.state.loading || this.props.status === 'rejected'}
        />

        {this.props.status !== 'rejected' && (
          <React.Fragment>
            <PrimaryButton
              type="button"
              style={{ height: '40px', padding: '0 40px' }}
              onClick={this.handleAcceptClick}
              disabled={this.state.loading}
            >
              Одобрить
            </PrimaryButton>

            <SecondaryButton
              type="button"
              style={{ marginLeft: '24px', height: '40px', padding: '0 40px' }}
              disabled={this.state.comment.length === 0 || this.props.status === 'rejected' || this.state.loading}
              onClick={this.handleRejectClick}
            >
              отклонить
            </SecondaryButton>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

UserProfileForm.propTypes = {
  id: PropTypes.string.isRequired,
  comment: PropTypes.string,
  status: PropTypes.oneOf(['created', 'accepted', 'rejected']),
  onStatusUpdate: PropTypes.func,
};

UserProfileForm.defaultProps = {
  comment: '',
  status: 'created',
  onStatusUpdate: () => {},
};

export default UserProfileForm;
